import { render, staticRenderFns } from "./SubjectGroupSelect.vue?vue&type=template&id=ace62b5e"
import script from "./SubjectGroupSelect.ts?vue&type=script&lang=ts&external"
export * from "./SubjectGroupSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports